<template>
    <div class="strategy-material-wrap">
        <Tabs :tabsConfig="tabsConfig" @tabClick="tabClick">
            <component :is="currentComponentName" :refercence="refercence" @checkClick="checkHandler" />
        </Tabs>
    </div>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs";
import VLinkTextGuides from "./components/VLinkTextGuides";

export default {
    name: "GuidesLibraryPage",
    props: ["refercence"],
    components: {
        Tabs,
        VLinkTextGuides
    },
    data() {
        return {
            currentComponentName: "VLinkTextGuides"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: this.$t("zhiji.materialLibrary.vlinkGuides"),
                    contentName: "VLinkTextGuides"
                }
            ];
        }
    },
    methods: {
        tabClick(data) {
            this.currentComponentName = data.componentName;
            this.$emit("tabClick", data);
        },
        checkHandler(data) {
            this.$emit("checkClick", data);
        }
    }
};
</script>

<style scoped lang="less">
.strategy-material-wrap {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
}
</style>
